import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatToolbarModule } from "@angular/material/toolbar";
import { RouterModule, Routes } from "@angular/router";
import { ElectionListComponent } from "./election-list.component";
const routes: Routes = [
  {
    path: "electionList/:_v",
    component: ElectionListComponent,
  },
];

@NgModule({
  declarations: [ElectionListComponent],
  imports: [
    RouterModule.forChild(routes),

    CommonModule,
    MatCardModule,
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    FlexLayoutModule,
  ],
})
export class ElectionListModule {}
